import { useEffect, useState } from "react";
import { client } from "../utils/axios-client";

export type StageOption = {
    value: string
    name: string
}
 
const useOptions = (optionType: string, config: any = null) => {
    const [options, setOptions] = useState<StageOption[]>([]);

    useEffect(() => {
        const loadOptions = async () => {
            const response = await client.get<StageOption[]>(`/api/options/${optionType}`, config);            
            setOptions(response.data);
        }

        loadOptions();
    }, [optionType, config]);

    return { options };
}

export default useOptions;
